import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

import {BaseService} from "app/views/base.service";
import { DataProvider2 } from "./provider/data2.provider";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

interface JWTAnswer {
	token: string;
	userId: string;
}

interface IAllowResourceMap {
	[key: string]: boolean;
}

interface IAccess {
	isAdmin: boolean;
	isAnyGranted: boolean;
	isGranted: boolean;
	isProvider: boolean;
	roles: string[];
}

interface IUserInfo {
	email: string;
	firstName: string;
	isAuth: boolean;
	lastName: string;
	username: string;
	_id: string;
}

@Injectable()
export class AuthService extends BaseService {
	public userId: string = '';
	
	// TODO Тут явно копируются поля из модели User - заменить!
	public email: string = '';
	public username: string = '';
	public firstName: string = '';
	public lastName: string = '';
	
	public resources = {};
	public roles: string[] = [];
	public isAuth = false;
	public loading = false;


	// Мы отличаем два состояния доступа:
	// 1. isGranted - разрешен доступ в конкретный отдел/отчет
	// 2. isAnyGranted - разрешен доступ в статистика вообще
	// Такое разделение нужно, поскольку:
	// - если пользователь недопущен в статистику вообще, не показывать меню
	// - если допущен, но не везде - показывать меню
	// Как только сделаем нормальную навигацию, и динамический показ меню,
	// тогда можно будет убрать такое различие.
	public isGranted = false;
	public isAnyGranted = false;
	public isAdmin = false;
	public isProvider = false;
	public allowedResources = {};
	
	// @deprecate
	public path = '';

	constructor(
		public http: HttpClient,
		public dp: DataProvider2,
		public router: Router,
		public location: Location,
		public activatedRoute: ActivatedRoute,
	) {
		super(http);
	}
	
	
	/**
	 * MIGR
	 * @returns {IUserInfo}
	 */
	getUser(): Observable<IUserInfo> {
		return this.dp.get('/get_user').pipe(
			map(r => <IUserInfo>r)
		);
	}


	async checkGrantForRoute(route: string = '') {
		const {
			isAnyGranted,
			isGranted,
			roles,
			isAdmin,
			isProvider,
		} = await this.dp.get<IAccess>('/access', { route }).toPromise();
		
		this.isAnyGranted = isAnyGranted;
		this.isGranted = isGranted;
		this.roles = roles;
		this.isAdmin = isAdmin;
		this.isProvider = isProvider;
	}
	
	async fetch(): Promise<void> {
		const me = this;

		const {
			isAuth, email, _id,
			username, firstName, lastName,
		} = await me.getUser().toPromise();
		
		me.userId = _id;
		me.isAuth = isAuth;
		me.email = email;
		me.username = username;
		me.firstName = firstName;
		me.lastName = lastName;
	}
	
	async loginByToken(): Promise<boolean> {
		const me = this;
		
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			withCredentials: true,
		};
		
		const { token } = await me.http.get<JWTAnswer>('https://ukit.com/admin/stat/jwt', httpOptions).toPromise();
		
		if ( ! token) {
			return false;
		}
		
		await me.dp.get('/login_by_token', {}, {
			headers: new HttpHeaders({
				'Authorization': 'Bearer ' + token,
			})
		}).toPromise();
			
		return true;
	}

	getAllowedResources(): Observable<IAllowResourceMap> {
		return this.dp.get('/allowed_resources').pipe(
			map(data => Object.keys(data).reduce(
				function(obj, resourceName) {
					obj[resourceName] = !!data[resourceName];
					return obj;
				},
				{}
			))
		);
	}

	async fetchAllowedResources(): Promise<void> {
		this.allowedResources = await this.getAllowedResources().toPromise();
	}


	signOut() {
		return this.dp.get('/sign_out').pipe(
			switchMap(() => {
				this.isAnyGranted = false;
				this.isGranted = false;
				this.roles = [];
				this.isAdmin = false;
				this.isProvider = false;
				this.allowedResources = {};
				
				return of(this.fetch())
			})
		);
	}
	
	isAllowResource(resource: string): boolean {
		return !!this.allowedResources[resource];
	}
}
